var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"loader py-5 py-lg-8"},[_c('div',{staticClass:"loader__item"}),_c('div',{staticClass:"loader__item"}),_c('div',{staticClass:"loader__item"}),(_vm.hasMessage)?_c('h4',{staticClass:"loader__message"},[_vm._t("message")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }